import withStyles from 'isomorphic-style-loader/withStyles';
import { Dimmer, Loader } from 'semantic-ui-react';

import s from './page-loader.scss';

export interface PageLoaderProps {
  message?: string;
}

/**
 * A reusable page dimmer with a loader which can display a custom message
 * @param props.message The message to display in the loader
 * @example
 * // Intended usage
 * <PageLoader message="Loading Images..." />
 */
const PageLoader = ({ message = 'Loading...' }: PageLoaderProps) => (
  <Dimmer className={s.root} active>
    <Loader size="huge" active inline="centered" content={message} />
  </Dimmer>
);

export default withStyles(s)(PageLoader);
